export const Tracking_Id = process.env.REACT_APP_TRACKING_ID;
export const GOOGL_MAPS_API_KEY = process.env.REACT_APP_GOOGL_MAPS_API_KEY;
